

module.exports = {
    color:{
        unknown: '#808080',
        healthy: "rgb(93,166,89)",
        attention:"rgb(250,234,42)",
        hazard:"rgb(233,78,26)",
        critical:"rgb(227,6,19)",
        detection: "rgb(138, 89, 166)"
    },
    getAlarmColorByOrder: function (order) {
        switch (order) {
            case -1: return  this.color.unknown
            case 0: return this.color.healthy
            case 1: return this.color.attention
            case 2: return this.color.hazard
            case 3: return this.color.critical
            case 4: return this.color.detection; //report
            case "healthy": return this.color.healthy;
            case "attention": return this.color.attention;
            case "hazard": return this.color.hazard;
            case "critical": return this.color.critical;
            case null: return this.color.unknown;
            default: return this.color.unknown;
        }
    }
    ,
    getRiskColor: function (percentage) {
        percentage = percentage % 101
        var gradient = [
            [
                0,
                [233, 77, 53]
            ],
            [
                70,
                [255, 171, 36]
            ],
            [
                85,
                [255, 252, 51]
            ],
            [
                90,
                [0, 230, 46]
            ]
        ];
        let colorRange = [0, 0]
        for (let i in gradient) {
            if (percentage >= gradient[i][0]) {
                colorRange[0] = gradient[i]
            }
            else {
                colorRange[1] = gradient[i]
                break;
            }
        }
        if (colorRange[1] == 0) {
            colorRange[1] = gradient[gradient.length - 1]
        }

        if (colorRange.length == 1) {
            colorRange[1] = colorRange[0]
        }

        var firstcolor = colorRange[0][1];
        var secondcolor = colorRange[1][1];

        //Calculate ratio between the two closest colors
        var width = colorRange[1][0] - colorRange[0][0]
        if (width == 0) return `rgb(${colorRange[1][1].join(',')})`
        width = width == 0 ? colorRange[0][0] / 2 : width
        var firstColorOffset = (colorRange[1][0] - percentage) / width
        var secondColorOffset = (percentage - colorRange[0][0]) / width
        var rgb =
            [
                Math.round(firstcolor[0] * firstColorOffset + secondcolor[0] * secondColorOffset),
                Math.round(firstcolor[1] * firstColorOffset + secondcolor[1] * secondColorOffset),
                Math.round(firstcolor[2] * firstColorOffset + secondcolor[2] * secondColorOffset)];
        //Get the color with pickHex(thx, less.js's mix function!)
        let color = `rgb(${rgb.join(',')})`
        return color;


    }
}